export enum UploadStatusesEnum {
  PENDING = 'PENDING',
  UPLOADED = 'UPLOADED',
  ERROR = 'ERROR',
}
